import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import NProgress from "nprogress";
import "nprogress/nprogress.css";

// Configure NProgress options
NProgress.configure({ showSpinner: false, speed: 400, minimum: 0.08 });

export function NavigationProgressBar() {
  const location = useLocation();

  useEffect(() => {
    // Start progress bar animation when location changes
    NProgress.start();
    
    // Complete the progress bar after a brief delay so it is visible and smooth
    const timer = setTimeout(() => {
      NProgress.done();
    }, 200);

    return () => {
      clearTimeout(timer);
      NProgress.done();
    };
  }, [location.pathname, location.search]);

  return null;
}
